export default __webpack_public_path__ + "static/media/impala.bc0a9247.svg";